module.exports = __webpack_public_path__ + "img/logout.f5f49630.svg";